import React, { createContext, useContext, useReducer } from "react";

export const AssetsContext = createContext(null);
export const StateProvider = ({ reducer, initialState, children }) => (
  <AssetsContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </AssetsContext.Provider>
);
export const useAssetsValue = () => useContext(AssetsContext);
